// import React from "react";
// import FooterComponent from "../WebSite/Footer/FooterComponent";
// import HeaderComponent from "../WebSite/Header/HeaderComponent";
// import DigitalTrust from "../../../src/images/aboutImg/closeup-shot-beekeeper-holding-honeycombs-frame-with-many-bees-making-honey.jpg";
// import Trading from "../../../src/images/gbrAbout/aboutimg4.webp";
// import Blockchain from "../../../src/images/aboutImg/business-success-concept-wooden-table-top-view-hands-protecting-wooden-figures-people (1).jpg";
// import Farming from "../../../src/images/aboutImg/shot-beekeeper-beekeeping-suit-standing-near-row-beehives-his-apiary-copyspace.jpg";
// import Values from "../../../src/images/gbrAbout/aboutimg6.webp";
// import CareImg from "../../../src/images/aboutImg/full-length-view-beekeeper-working-landscapes-with-confident-expression-agrarian-natural-summer-honeycombs-concept.jpg";
// import TeamImg from "../../../src/images/gbrAbout/aboutimg7.webp";
// import "react-awesome-slider/dist/styles.css";
// import AboutBanner from "./AboutBanner";
// import AboutSubSection from "../aboutSubSection/AboutSubSection";

// export default function AboutusComponent() {
//   return (
//     <>
//       <HeaderComponent />
//       <AboutBanner />
//       <div className="about-main-wrapper">
//         <AboutSubSection
//           className="rowReverseAbout"
//           // description="GBR create Social & Business Impact by transforming the Agri-producers into Agri-Entrepreneurs & Agri-Entrepreneurs into Agri-Business.
// description="GBR generates social and economic impact by transforming Agri-producers to become agri-entrepreneurs and agri-business into AAMC."
//           // description="GBR generates social and business impact by empowering Agri-producers to become Agri-entrepreneurs through transformational initiatives."

//           title="Why We Exist"
//           src={Farming}
//         />

//         <AboutSubSection
//           className1="aboutBgGrey"
//           className="rowReverseAbout--mod"
//           // description="GBR introducing Profit-generating Assets for Agri-Entrepreneurs."
//         description="GBR is transforming the farming landscape by introducing Profit-generating Assets (Agri-asset class) that empower agri-business and agri-entrepreneurs to thrive and prosper."
//           title="
//         Who We Are"
//           src={DigitalTrust}
//         />

//         <AboutSubSection
//           className="rowReverseAbout"
//           description="GBR care about Agri-business  who want to expand their line of business."
//           // description="GBR is dedicated to supporting Agri-producers who aspire to transition into agri-entrepreneurs."

//           title=" Whom We Care About"
//           src={CareImg}
//         />
//         <AboutSubSection
//           className1="aboutBgGrey"
//           className="rowReverseAbout--mod"
//           description={[
//             " We have introduced a novel income-generation scheme along with a mobile app and secure SAAS (Software as a Service) offerings, as outlined below:",
//           ]}
//           // description1={[
//           //   <strong>IMA:&nbsp;</strong>,
//           //   ` Investable Machinery Assets for agri-entrepreneurs.`,
//           // ]}
//           // description2={[
//           //   <strong>IAA:&nbsp;</strong>,
//           //   " Investable Agri Assets for agri-entrepreneurs and Agri-producers.",
//           // ]}

//           description3={[
//             <strong>AAMC:&nbsp;</strong>,
//             "We enable Agri-entrepreneurs to manage agri-assets in their own farm to improve production.",
//           ]}

//           description4={[
//             <strong>onMarketplace:&nbsp;</strong>,
//             "We provide organic D2C marketplace to Buy and Sell organic products",
//           ]}

//           description5={[
//             <strong>Social onMarketplace:&nbsp;</strong>,
//             "We provide a social B2B marketplace where businesses can interact with each other to make informed decisions about buying",
//           ]}

//           description6={[
//             <strong>Social iaaMarketplace:&nbsp;</strong>,
//             "We provide iaaMarketplace where investor can invest in to Agri-business and Agri-assets ",
//           ]}
//           // description4={[
//           //   <strong>Community:&nbsp;</strong>,

//           //   "We enable agri-entrepreneurs to manage the Organic certificate for the community (Producers). ",
//           // ]}
//           // description5={[
//           //   <strong> Billing Services:&nbsp;</strong>,
//           //   " Billing Services like invoice and purchase order management.",
//           // ]}
        
         

//           // description6={[
//           //   <strong> Ecosystem:&nbsp;</strong>,
//           //   "Ecosystem for agri-entrepreneurs to get advise , buy, sell and create trust.",
//           // ]}
//           // description7={[
//           //   <strong>Buy back services: &nbsp;</strong>,
//           //   "Buy back option for approved agri-entrepreneurs.",
//           // ]}
//           title="What We Do"
//           src={Trading}
//         />
//         <AboutSubSection
//           className="rowReverseAbout"
//           description="GBR Introducing Profit-generating Assets, Agri-Business Network, Agri asset management cloud and Production network for Agri-business."
//           title="How We Do It"
//           src={Blockchain}
//         />

//         <AboutSubSection
//           className1="aboutBgGrey"
//           className="rowReverseAbout--mod"
//           description16="Innovation and Value Creation"
//           description1="We continuously work on VALUE CREATION for Producers
//         through technology as an enabler. We encourage Innovation and Challenge the status quo."
//           description17="Passion"
//           description8="We are ambitious and believe in Teamwork
//        to achieve more when we collaborate and all work together."
//           description18="Courage and Trust"
//           description12=" We are willing to take risks and
//         Win-Win Partnerships With Our Business Partners. We view
//         Producers Service Providers and financial partners as trustworthy
//         allies in serving Agri-producers."
//           description19="Equality"
//           description20="We treat Producers and Partners with
//         respect, fairness, transparency and integrity. We embrace Diversity of experience, Culture and Opinions and belive in sharing as learning for everyone."
//           title="Our Culture & Values"
//           src={Values}
//         />
//         <AboutSubSection
//           className1="pb-0"
//           className="rowReverseAbout "
//           description="Our exceptional team, from dedicated employees to visionary leaders, fuels our success and propels us towards new heights. With open communication, trust, and collaboration at the core, we embrace innovation and achieve collective greatness. Together, we are shaping the future and proudly driving GBR forward."
//           title="
//         Our Team"
//           src={TeamImg}
//         />
//       </div>

//       <FooterComponent />
//     </>
//   );
// }
import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import Section1Component from "./Section1Component";
import DigitalTrust from "../../../src/images/gbrAbout/aboutimg2.webp";

import Trading from "../../../src/images/gbrAbout/aboutimg4.webp";
import Blockchain from "../../../src/images/gbrAbout/aboutimg5.webp";
import Farming from "../../../src/images/gbrAbout/aboutimg1.webp";
import Values from "../../../src/images/gbrAbout/aboutimg6.webp";
import CareImg from "../../../src/images/gbrAbout/aboutimg3.webp";
import TeamImg from "../../../src/images/gbrAbout/aboutimg7.webp";
import "react-awesome-slider/dist/styles.css";
import AboutBanner from "./AboutBanner";
import AboutSubSection from "../aboutSubSection/AboutSubSection";
import { Row, Col } from "react-bootstrap";
import test1 from "../../../src/images/ServiceIcons/CBN.svg";
import AboutListMain from "../AboutList/AboutListMain";
import LandingPageBanner from "../WebSite/LandingPageBanner/LandingPageBanner";

export default function AboutusComponent() {
  // var parse = require("html-react-parser");

  return (
    <>
      <HeaderComponent />
     <LandingPageBanner />
  <div className="about-main-wrapper">

  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&family=DM+Sans:wght@300;400;500&display=swap');

    .about-main-wrapper * { box-sizing: border-box; }
    .about-main-wrapper { font-family: 'DM Sans', sans-serif; }

    .abw-section-wrap { background: #fff; }
    .abw-section-wrap--grey { background: #f4f8f4; }
    .abw-section {
      max-width: 1140px; margin: 0 auto;
      padding: 80px 24px; display: flex;
      align-items: center; gap: 64px;
    }
    .abw-section--rev { flex-direction: row-reverse; }
    .abw-section__img-col { flex: 0 0 460px; }
    .abw-section__img {
      width: 100%; aspect-ratio: 4/3;
      object-fit: cover; border-radius: 16px; display: block;
    }
    .abw-section__text { flex: 1; min-width: 0; }
    .abw-eyebrow {
      display: flex; align-items: center; gap: 8px;
      font-size: 11px; font-weight: 700; letter-spacing: 0.14em;
      text-transform: uppercase; color: #1D9E75; margin-bottom: 14px;
    }
    .abw-eyebrow__dot {
      width: 7px; height: 7px; border-radius: 50%;
      background: #1D9E75; flex-shrink: 0;
    }
    .abw-h2 {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1.6rem, 3vw, 2.1rem);
      font-weight: 400; line-height: 1.25; color: #0f1f0f; margin: 0 0 16px;
    }
    .abw-body { font-size: 15px; line-height: 1.8; color: #456045; margin: 0 0 20px; }

    /* WHO WE ARE */
    .abw-whoweare { background: #f4f8f4; padding: 80px 24px; }
    .abw-whoweare__inner {
      max-width: 1140px; margin: 0 auto;
      display: flex; align-items: center; gap: 64px;
    }
    .abw-whoweare__img-col { flex: 0 0 460px; }
    .abw-whoweare__img {
      width: 100%; aspect-ratio: 4/3;
      object-fit: cover; border-radius: 16px; display: block;
    }
    .abw-whoweare__text { flex: 1; min-width: 0; }
    .abw-whoweare__headline {
      font-family: 'Playfair Display', serif;
      font-size: clamp(2rem, 4vw, 2.8rem);
      font-weight: 400; line-height: 1.18; color: #0f1f0f; margin: 0 0 18px;
    }
    .abw-whoweare__headline em { font-style: italic; color: #1D9E75; }
    .abw-whoweare__sub { font-size: 16px; line-height: 1.8; color: #456045; margin: 0 0 28px; }
    .abw-whoweare__tagline {
      display: inline-flex; align-items: center; gap: 10px;
      background: #E1F5EE; border: 1px solid #9FE1CB;
      border-radius: 10px; padding: 14px 20px;
      font-size: 14px; font-weight: 500; color: #085041; line-height: 1.55;
    }

    /* CONTRAST CARDS */
    .abw-contrast-grid {
      display: grid; grid-template-columns: repeat(3, 1fr);
      gap: 10px; margin-bottom: 16px;
    }
    .abw-contrast-card {
      background: #fff; border: 1px solid #c6dfc6;
      border-radius: 10px; padding: 14px 16px;
    }
    .abw-contrast-card__top { font-size: 13px; font-weight: 600; color: #0f1f0f; margin-bottom: 4px; }
    .abw-contrast-card__btm { font-size: 12px; color: #993C1D; }

    /* BANNERS */
    .abw-banner { padding: 13px 18px; border-radius: 0 8px 8px 0; font-size: 14px; font-weight: 600; }
    .abw-banner--green { background: #edf7f1; border-left: 3px solid #1D9E75; color: #085041; }
    .abw-banner--red   { background: #fff5f0; border-left: 3px solid #D85A30; color: #712B13; }

    /* OFFER CARDS */
    .abw-offer-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
    .abw-offer-card {
      background: #fff; border: 1px solid #c6dfc6;
      border-radius: 12px; padding: 22px;
    }
    .abw-offer-tag {
      display: inline-block; font-size: 10px; font-weight: 700;
      letter-spacing: 0.07em; text-transform: uppercase;
      background: #E1F5EE; color: #085041;
      padding: 3px 12px; border-radius: 20px; margin-bottom: 12px;
    }
    .abw-offer-title { font-size: 15px; font-weight: 600; color: #0f1f0f; margin: 0 0 8px; }
    .abw-offer-desc  { font-size: 13px; line-height: 1.6; color: #456045; margin: 0; }

    /* PILLS */
    .abw-pill-row { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 8px; }
    .abw-pill {
      background: #edf7f1; border: 1px solid #9FE1CB;
      border-radius: 24px; padding: 7px 18px;
      font-size: 14px; font-weight: 500; color: #085041;
    }

    /* PROBLEM CARDS */
    .abw-problem-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }
    .abw-problem-card {
      background: #fff8f6; border: 1px solid #F5C4B3;
      border-radius: 10px; padding: 16px;
    }
    .abw-problem-dot {
      display: block; width: 8px; height: 8px;
      border-radius: 50%; background: #D85A30; margin-bottom: 10px;
    }
    .abw-problem-title { font-size: 14px; font-weight: 600; color: #0f1f0f; margin: 0 0 4px; }
    .abw-problem-desc  { font-size: 12.5px; line-height: 1.55; color: #456045; margin: 0; }

    /* APPROACH */
    .abw-approach-grid {
      display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
      gap: 10px; margin-top: 4px;
    }
    .abw-approach-item {
      background: #edf7f1; border: 1px solid #9FE1CB;
      border-radius: 8px; padding: 13px 15px;
      font-size: 13px; font-weight: 500; color: #085041;
      display: flex; align-items: center; gap: 10px;
    }
    .abw-approach-item__dot {
      width: 6px; height: 6px; border-radius: 50%;
      background: #1D9E75; flex-shrink: 0;
    }

    /* VISION MISSION */
    .abw-vm-band {
      background: #edf7f1; padding: 80px 24px;
      border-top: 1px solid #c6dfc6; border-bottom: 1px solid #c6dfc6;
    }
    .abw-vm-inner {
      max-width: 960px; margin: 0 auto;
      display: flex; align-items: stretch; gap: 0;
    }
    .abw-vm-card { flex: 1; padding: 0 52px; }
    .abw-vm-card:first-child { padding-left: 0; }
    .abw-vm-card:last-child  { padding-right: 0; }
    .abw-vm-label {
      font-size: 11px; font-weight: 700; letter-spacing: 0.14em;
      text-transform: uppercase; color: #1D9E75; margin-bottom: 14px;
    }
    .abw-vm-text {
      font-family: 'Playfair Display', serif;
      font-size: 1.35rem; font-weight: 400; line-height: 1.5;
      color: #0f1f0f; margin: 0;
    }
    .abw-vm-sep { width: 1px; background: #9FE1CB; flex-shrink: 0; align-self: stretch; }

    /* FEATURE BAND */
    .abw-feature-band { background: #f4f8f4; padding: 80px 24px; text-align: center; }
    .abw-feature-band__inner { max-width: 900px; margin: 0 auto; }
    .abw-feature-band__title {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1.6rem, 3vw, 2.2rem);
      font-weight: 400; color: #0f1f0f; margin: 0 0 14px;
    }
    .abw-feature-band__sub {
      font-size: 15px; line-height: 1.75; color: #456045;
      margin: 0 auto 44px; max-width: 640px;
    }
    .abw-feature-grid {
      display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 16px; text-align: left;
    }
    .abw-feature-card {
      background: #fff; border: 1px solid #c6dfc6;
      border-radius: 14px; padding: 24px;
    }
    .abw-feature-card__num {
      font-family: 'Playfair Display', serif;
      font-size: 2rem; font-weight: 600; color: #1D9E75;
      line-height: 1; margin-bottom: 12px;
    }
    .abw-feature-card__title { font-size: 15px; font-weight: 600; color: #0f1f0f; margin: 0 0 8px; }
    .abw-feature-card__desc  { font-size: 13px; line-height: 1.6; color: #456045; margin: 0; }

    /* CULTURE & VALUES */
    .abw-culture-wrap { background: #fff; padding: 90px 24px; }
    .abw-culture-inner { max-width: 1140px; margin: 0 auto; }
    .abw-culture-header {
      display: flex; align-items: flex-end;
      justify-content: space-between; gap: 40px; margin-bottom: 52px;
    }
    .abw-culture-header__left { max-width: 560px; }
    .abw-culture-header__tagline {
      font-size: 15px; line-height: 1.75; color: #456045;
      max-width: 340px; text-align: right; font-style: italic;
    }
    .abw-culture-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
    .abw-culture-card {
      background: #f4f8f4; border: 1px solid #c6dfc6;
      border-radius: 16px; padding: 28px 26px;
    }
    .abw-culture-card--featured { background: #1D9E75; border-color: #1D9E75; }
    .abw-culture-card__number {
      font-family: 'Playfair Display', serif;
      font-size: 2.8rem; font-weight: 600;
      color: #c6dfc6; line-height: 1; margin-bottom: 16px;
    }
    .abw-culture-card--featured .abw-culture-card__number { color: rgba(255,255,255,0.25); }
    .abw-culture-card__title { font-size: 16px; font-weight: 600; color: #0f1f0f; margin: 0 0 10px; line-height: 1.3; }
    .abw-culture-card--featured .abw-culture-card__title { color: #fff; }
    .abw-culture-card__desc { font-size: 13.5px; line-height: 1.7; color: #456045; margin: 0; }
    .abw-culture-card--featured .abw-culture-card__desc { color: rgba(255,255,255,0.80); }
    .abw-culture-card__bar { width: 32px; height: 3px; background: #1D9E75; border-radius: 2px; margin-bottom: 18px; }
    .abw-culture-card--featured .abw-culture-card__bar { background: rgba(255,255,255,0.5); }
    .abw-culture-bottom {
      margin-top: 20px; background: #edf7f1;
      border: 1px solid #9FE1CB; border-radius: 14px;
      padding: 28px 32px; display: flex; align-items: center; gap: 32px;
    }
    .abw-culture-bottom__label {
      font-size: 11px; font-weight: 700; letter-spacing: 0.13em;
      text-transform: uppercase; color: #1D9E75; white-space: nowrap;
    }
    .abw-culture-bottom__sep { width: 1px; height: 40px; background: #9FE1CB; flex-shrink: 0; }
    .abw-culture-bottom__text { font-size: 15px; line-height: 1.7; color: #085041; margin: 0; font-style: italic; }

    /* TEAM */
    .abw-team-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 8px; }
    .abw-team-card { background: #fff; border: 1px solid #c6dfc6; border-radius: 12px; padding: 20px; }
    .abw-team-role { font-size: 14px; font-weight: 600; color: #0f1f0f; margin: 0 0 7px; }
    .abw-team-desc { font-size: 13px; line-height: 1.6; color: #456045; margin: 0; }

    /* ── DIVISIONS FINAL SECTION — REDESIGNED ── */
    .abw-div-outer {
      background: #1D9E75;
      padding: 0;
    }
    .abw-div-intro-band {
      background: #1D9E75;
      padding: 80px 24px 60px;
      text-align: center;
    }
    .abw-div-intro-band__inner { max-width: 780px; margin: 0 auto; }
    .abw-div-intro-band__overline {
      display: inline-flex; align-items: center; gap: 8px;
      font-size: 11px; font-weight: 700; letter-spacing: 0.16em;
      text-transform: uppercase; color: rgba(255,255,255,0.65);
      margin-bottom: 20px;
    }
    .abw-div-intro-band__overline-dot {
      width: 6px; height: 6px; border-radius: 50%;
      background: rgba(255,255,255,0.5);
    }
    .abw-div-intro-band__h2 {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1.9rem, 4vw, 2.8rem);
      font-weight: 400; line-height: 1.18; color: #fff;
      margin: 0 0 20px;
    }
    .abw-div-intro-band__h2 em { font-style: italic; color: rgba(255,255,255,0.75); }
    .abw-div-intro-band__sub {
      font-size: 16px; line-height: 1.8;
      color: rgba(255,255,255,0.72); margin: 0;
    }

    /* CARDS TRAY — sits on white, overlapping green above */
    .abw-div-cards-tray {
      background: #f4f8f4;
      padding: 0 24px 80px;
    }
    .abw-div-cards-inner {
      max-width: 1140px;
      margin: 0 auto;
    }
    .abw-div-gap-banner {
      background: #fff;
      border: 1px solid #F5C4B3;
      border-radius: 14px;
      padding: 20px 28px;
      margin-bottom: 36px;
      display: flex;
      align-items: flex-start;
      gap: 14px;
      transform: translateY(-36px);
      box-shadow: 0 4px 24px rgba(29,158,117,0.08);
    }
    .abw-div-gap-banner__dot {
      width: 10px; height: 10px; border-radius: 50%;
      background: #D85A30; flex-shrink: 0; margin-top: 5px;
    }
    .abw-div-gap-banner__text {
      font-size: 15px; line-height: 1.75; color: #456045; margin: 0;
    }
    .abw-div-gap-banner__text strong { color: #712B13; font-weight: 600; }

    .abw-div-grid {
      display: grid; grid-template-columns: 1fr 1fr;
      gap: 24px; margin-bottom: 24px;
      margin-top: -36px;
    }
    .abw-div-card {
      border-radius: 20px; padding: 40px 36px;
      display: flex; flex-direction: column;
      border: 1px solid transparent;
      box-shadow: 0 2px 20px rgba(0,0,0,0.06);
    }
    .abw-div-card--network {
      background: #fff;
      border-color: #c6dfc6;
    }
    .abw-div-card--si {
      background: #0a1f0e;
      border-color: #0a1f0e;
    }

    .abw-div-card__badge {
      display: inline-flex; align-items: center; gap: 8px;
      font-size: 10px; font-weight: 700; letter-spacing: 0.12em;
      text-transform: uppercase; border-radius: 20px;
      padding: 4px 14px; margin-bottom: 28px; width: fit-content;
    }
    .abw-div-card--network .abw-div-card__badge {
      background: #E1F5EE; color: #085041; border: 1px solid #9FE1CB;
    }
    .abw-div-card--si .abw-div-card__badge {
      background: rgba(29,158,117,0.15); color: #5DCAA5;
      border: 1px solid rgba(29,158,117,0.25);
    }

    .abw-div-card__num {
      font-family: 'Playfair Display', serif;
      font-size: 3.2rem; font-weight: 600; line-height: 1; margin-bottom: 6px;
    }
    .abw-div-card--network .abw-div-card__num { color: #c6dfc6; }
    .abw-div-card--si      .abw-div-card__num { color: rgba(255,255,255,0.1); }

    .abw-div-card__headline {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1.3rem, 2.2vw, 1.65rem);
      font-weight: 400; line-height: 1.25; margin: 0 0 8px;
    }
    .abw-div-card--network .abw-div-card__headline { color: #0f1f0f; }
    .abw-div-card--si      .abw-div-card__headline { color: #fff; }

    .abw-div-card__distinction {
      display: inline-block;
      font-size: 12px; font-weight: 700; letter-spacing: 0.06em;
      text-transform: uppercase; padding: 4px 12px;
      border-radius: 20px; margin-bottom: 20px;
    }
    .abw-div-card--network .abw-div-card__distinction {
      background: #E1F5EE; color: #0F6E56;
    }
    .abw-div-card--si .abw-div-card__distinction {
      background: rgba(93,202,165,0.12); color: #5DCAA5;
    }

    .abw-div-card__for {
      font-size: 13.5px; line-height: 1.7; margin-bottom: 24px;
      padding-bottom: 24px;
    }
    .abw-div-card--network .abw-div-card__for {
      color: #456045;
      border-bottom: 1px solid #e8f2e8;
    }
    .abw-div-card--si .abw-div-card__for {
      color: rgba(255,255,255,0.55);
      border-bottom: 1px solid rgba(255,255,255,0.08);
    }

    .abw-div-card__list {
      list-style: none; padding: 0; margin: 0 0 28px;
      display: flex; flex-direction: column; gap: 11px;
    }
    .abw-div-card__list li {
      display: flex; align-items: center; gap: 12px;
      font-size: 14px; line-height: 1.5;
    }
    .abw-div-card--network .abw-div-card__list li { color: #0f1f0f; }
    .abw-div-card--si      .abw-div-card__list li { color: rgba(255,255,255,0.85); }
    .abw-div-card__list li::before {
      content: '';
      display: inline-block; width: 6px; height: 6px;
      border-radius: 50%; flex-shrink: 0;
    }
    .abw-div-card--network .abw-div-card__list li::before { background: #1D9E75; }
    .abw-div-card--si      .abw-div-card__list li::before { background: #5DCAA5; }

    .abw-div-card__shift {
      font-size: 13px; font-weight: 600;
      padding: 11px 16px; border-radius: 8px; margin-bottom: 28px;
    }
    .abw-div-card--network .abw-div-card__shift {
      background: #edf7f1; color: #085041;
      border: 1px solid #9FE1CB;
    }
    .abw-div-card--si .abw-div-card__shift {
      background: rgba(29,158,117,0.1); color: #5DCAA5;
      border: 1px solid rgba(29,158,117,0.2);
    }

    .abw-div-card__cta {
      display: inline-flex; align-items: center; justify-content: center; gap: 10px;
      font-size: 14px; font-weight: 600;
      padding: 14px 24px; border-radius: 10px;
      text-decoration: none; cursor: pointer; border: none;
      margin-top: auto; transition: opacity 0.15s ease;
      width: 100%;
    }
    .abw-div-card__cta:hover { opacity: 0.88; }
    .abw-div-card--network .abw-div-card__cta { background: #1D9E75; color: #fff; }
    .abw-div-card--si      .abw-div-card__cta { background: #1D9E75; color: #fff; }
    .abw-div-card__cta-arrow { font-size: 17px; }

    .abw-div-card__listlabel {
      font-size: 11px; font-weight: 700; letter-spacing: 0.1em;
      text-transform: uppercase; margin: 0 0 16px;
    }
    .abw-div-card--network .abw-div-card__listlabel { color: #0F6E56; }
    .abw-div-card--si      .abw-div-card__listlabel { color: #5DCAA5; }

    .abw-div-card__focus {
      font-size: 13px; line-height: 1.6; font-weight: 600;
      margin-top: auto; padding-top: 20px; border-top: 1px solid;
    }
    .abw-div-card--network .abw-div-card__focus { color: #085041; border-top-color: #e8f2e8; }
    .abw-div-card--si      .abw-div-card__focus { color: #5DCAA5; border-top-color: rgba(255,255,255,0.08); }

    /* TOGETHER BLOCK */
    .abw-div-together {
      background: #fff; border: 1px solid #c6dfc6; border-radius: 16px;
      padding: 40px 44px;
    }
    .abw-div-together__text {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1rem, 1.7vw, 1.2rem);
      font-weight: 400; line-height: 1.7; color: #0f1f0f;
      margin: 0 0 14px;
    }
    .abw-div-together__text:last-of-type { margin-bottom: 0; }
    .abw-div-together__text em { font-style: italic; color: #1D9E75; }
    .abw-div-together__flow {
      margin-top: 26px; padding-top: 24px;
      border-top: 1px dashed #c6dfc6;
      display: flex; flex-direction: column; gap: 12px;
    }
    .abw-div-together__flow-row {
      display: flex; flex-wrap: wrap; align-items: center; gap: 8px;
      font-size: 14.5px; font-weight: 600; color: #085041;
    }
    .abw-div-together__flow-row--sub { font-size: 13.5px; color: #456045; font-weight: 500; }
    .abw-div-together__flow-row span.abw-arrow { color: #1D9E75; font-weight: 700; }

    .abw-div-card__focustag {
      font-size: 13px; line-height: 1.6; font-weight: 500; margin: 0;
    }
    .abw-div-card--network .abw-div-card__focustag { color: #456045; }
    .abw-div-card--si      .abw-div-card__focustag { color: rgba(255,255,255,0.65); }

    .abw-div-together__title {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1.05rem, 1.9vw, 1.3rem);
      font-weight: 400; text-align: center; color: #0f1f0f;
      margin: 0 0 32px;
    }
    .abw-div-diagram {
      display: flex; flex-direction: column; align-items: center; gap: 0;
      margin-bottom: 32px;
    }
    .abw-div-diagram__box {
      background: #fff; border: 1px solid #c6dfc6; border-radius: 12px;
      padding: 14px 26px; text-align: center; width: 100%; max-width: 420px;
    }
    .abw-div-diagram__box--dark { background: #0a1f0e; border-color: #0a1f0e; }
    .abw-div-diagram__box--accent { background: #1D9E75; border-color: #1D9E75; }
    .abw-div-diagram__box-title { font-weight: 700; font-size: 14px; color: #0f1f0f; margin: 0 0 4px; }
    .abw-div-diagram__box--dark .abw-div-diagram__box-title,
    .abw-div-diagram__box--accent .abw-div-diagram__box-title { color: #fff; }
    .abw-div-diagram__box-sub { font-size: 12.5px; color: #456045; margin: 0; }
    .abw-div-diagram__box--dark .abw-div-diagram__box-sub { color: rgba(255,255,255,0.65); }
    .abw-div-diagram__box--accent .abw-div-diagram__box-sub { color: rgba(255,255,255,0.85); }
    .abw-div-diagram__arrow { color: #1D9E75; font-size: 20px; line-height: 1.4; }
    .abw-div-diagram__split {
      display: flex; gap: 14px; justify-content: center; width: 100%; max-width: 560px;
    }
    .abw-div-diagram__split .abw-div-diagram__box { flex: 1; max-width: 190px; padding: 12px 10px; }
    .abw-div-diagram__split-arrows {
      display: flex; gap: 14px; justify-content: center; width: 100%; max-width: 560px;
    }
    .abw-div-diagram__split-arrows span { flex: 1; max-width: 190px; text-align: center; color: #1D9E75; font-size: 18px; }

    /* CLOSING LINE */
    .abw-div-unifier {
      background: #fff;
      border: 1px solid #c6dfc6;
      border-radius: 16px;
      padding: 36px 44px;
      display: flex;
      align-items: center;
      gap: 28px;
    }
    .abw-div-unifier__icon {
      width: 48px; height: 48px; border-radius: 12px;
      background: #1D9E75; flex-shrink: 0;
      display: flex; align-items: center; justify-content: center;
    }
    .abw-div-unifier__icon-dot {
      width: 16px; height: 16px; border-radius: 50%;
      background: rgba(255,255,255,0.7);
    }
    .abw-div-unifier__sep {
      width: 1px; height: 48px;
      background: #c6dfc6; flex-shrink: 0;
    }
    .abw-div-unifier__text {
      font-family: 'Playfair Display', serif;
      font-size: clamp(1rem, 1.8vw, 1.25rem);
      font-weight: 400; line-height: 1.6;
      color: #0f1f0f; margin: 0;
    }
    .abw-div-unifier__text em { font-style: italic; color: #1D9E75; }

    /* RESPONSIVE */
    @media (max-width: 960px) {
      .abw-whoweare__inner, .abw-section {
        flex-direction: column !important; gap: 36px; padding: 56px 20px;
      }
      .abw-whoweare__img-col, .abw-section__img-col { flex: unset; width: 100%; }
      .abw-contrast-grid { grid-template-columns: 1fr; }
      .abw-culture-grid { grid-template-columns: 1fr 1fr; }
      .abw-culture-header { flex-direction: column; align-items: flex-start; }
      .abw-culture-header__tagline { text-align: left; }
      .abw-div-grid { grid-template-columns: 1fr; }
      .abw-div-unifier { flex-direction: column; align-items: flex-start; gap: 16px; }
      .abw-div-unifier__sep { width: 40px; height: 1px; }
    }
    @media (max-width: 600px) {
      .abw-offer-grid, .abw-problem-grid, .abw-team-grid { grid-template-columns: 1fr; }
      .abw-vm-inner { flex-direction: column; gap: 40px; }
      .abw-vm-card { padding: 0; }
      .abw-vm-sep { width: 48px; height: 1px; align-self: auto; }
      .abw-culture-grid { grid-template-columns: 1fr; }
      .abw-culture-bottom { flex-direction: column; align-items: flex-start; gap: 16px; }
      .abw-culture-bottom__sep { width: 40px; height: 1px; }
      .abw-div-card { padding: 28px 22px; }
      .abw-div-intro-band { padding: 60px 20px 48px; }
      .abw-div-cards-tray { padding: 0 20px 60px; }
      .abw-div-together { padding: 28px 22px; }
      .abw-div-together__flow-row { font-size: 13px; }
      .abw-div-diagram__split, .abw-div-diagram__split-arrows { flex-direction: column; align-items: center; }
      .abw-div-diagram__split .abw-div-diagram__box { max-width: 260px; width: 100%; }
    }
  `}</style>

  {/* ── WHO WE ARE ───────────────────────────────────────── */}
 <div className="abw-whoweare">
  <div className="abw-whoweare__inner">
    <div className="abw-whoweare__img-col">
      <img className="abw-whoweare__img"
        src="https://images.unsplash.com/photo-1564457461758-8ff96e439e83?w=900&auto=format&fit=crop"
        alt="Modern data center with rows of server cabinets" />
    </div>
    <div className="abw-whoweare__text">
       {/*  <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />Who We Are</p> */}
        <h4 className="container-title">
        Who We Are
        </h4>
        
      <h1 className="abw-whoweare__headline">AI-native Ecosystem Infrastructure company and Ecosystem Infrastructure Operator <em>focused on the agrifood economy </em></h1>
      <p className="abw-whoweare__sub">
        GBR Farming enables agrifood organizations to own, operate, and monetize their ecosystems — not just participate in them.
      </p>
      <div className="abw-whoweare__tagline">
        We build Ecosystem Infrastructure that connects people, businesses, assets, data, and AI into intelligent ecosystem networks — helping organizations become Ecosystem Network Operators and create greater value for everyone they serve.
      </div>
    </div>
  </div>
</div>

  {/* ── WHY WE EXIST ─────────────────────────────────────── */}
  <div id="purpose"
       className="abw-section-wrap">
    <div className="abw-section abw-section--rev">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
       /*    src="https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=900&auto=format&fit=crop"
          alt="Farmer in field at sunrise" /> */

          /*  src="https://images.pexels.com/photos/10325707/pexels-photo-10325707.png?cs=srgb&dl=pexels-lucasdc-10325707.jpg&fm=jpg" */
         /*  src="https://images.unsplash.com/photo-1772694624284-f0526c2bf63e?auto=format&fit=crop&w=1200&q=80" */
         /* src="https://images.pexels.com/photos/30557705/pexels-photo-30557705/free-photo-of-aerial-view-of-agricultural-fields-with-road.jpeg?auto=compress&cs=tinysrgb&w=1200" */
         src="https://images.unsplash.com/photo-1771131825971-af45a242808c?auto=format&fit=crop&w=1200&q=80"
  alt="Connected digital network representing ecosystem infrastructure" 
  /* src= "https://images.unsplash.com/photo-1786913508089-e27084a2bc52?auto=format&fit=crop&w=1200&q=80"
   alt="Connected digital network representing ecosystem infrastructure"  */
        />
          
      </div>
      <div className="abw-section__text">
      {/*   <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />Why We Exist</p> */}
        <h4 className="container-title"> 
       Why We Exist
          </h4>
     

        <h2 className="abw-h2">Helping organisations move from operating a business to operating an ecosystem.</h2>
        <p className="abw-body">Organisations today have  an ecosystem but do not truly own or benefit from the ecosystem. GBR Farming exists to bridge that gap.</p>
        <div className="abw-contrast-grid">
          <div className="abw-contrast-card"><p className="abw-contrast-card__top">Ecosystems exist</p><p className="abw-contrast-card__btm">but are not owned</p></div>
          <div className="abw-contrast-card"><p className="abw-contrast-card__top">Value is created</p><p className="abw-contrast-card__btm">but not captured</p></div>
          <div className="abw-contrast-card"><p className="abw-contrast-card__top">Networks operate</p><p className="abw-contrast-card__btm">but not orchestrated</p></div>
        </div>
        <div className="abw-banner abw-banner--green">GBR Farming exists to solve this.</div>
      </div>
    </div>
  </div>

  {/* ── WHAT WE DO ───────────────────────────────────────── */}
  <div className="abw-section-wrap abw-section-wrap--grey">
    <div className="abw-section">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
          /* src="https://images.unsplash.com/photo-1586771107445-d3ca888129ff?w=900&auto=format&fit=crop"
          alt="Agri technology and trading operations" /> */
           src="https://images.pexels.com/photos/30547618/pexels-photo-30547618.jpeg?cs=srgb&dl=pexels-pachon-in-motion-426015731-30547618.jpg&fm=jpg"
          alt="Digital infrastructure connecting ecosystem components" 
          
          />

      </div>
      <div className="abw-section__text">
      {/*   <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />What We Do</p> */}
         <h4 className="container-title">
         What We Do
          </h4>
        <h2 className="abw-h2">Transitioning agrifood organisations into ecosystem network operators</h2>
        <p className="abw-body">We enable agrifood business to transition into ecosystem network operators through two core offerings:</p>
        <div className="abw-offer-grid">
          <div className="abw-offer-card">
            {/* <span className="abw-offer-tag">Mid-market</span> */}
            <p className="abw-offer-title">Ecosystem Orchestration Platform (EOP)</p>
            <p className="abw-offer-desc">A platform that connects, coordinates, and orchestrates participants, processes, systems, and data across an ecosystem.</p>
          </div>
          <div className="abw-offer-card">
          {/*   <span className="abw-offer-tag">Enterprise</span> */}
            <p className="abw-offer-title">AI Ecosystem Builder Framework</p>
            <p className="abw-offer-desc">An ecosystem network framework for designing, building and deploying interconnected ecosystem networks and micro-ecosystems.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* ── WHOM WE CARE ABOUT ───────────────────────────────── */}
  <div className="abw-section-wrap">
    <div className="abw-section abw-section--rev">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
         /*  src="https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=900&auto=format&fit=crop"
          alt="Farmers and agribusiness partners" /> */
          /* src ="https://images.pexels.com/photos/6949494/pexels-photo-6949494.jpeg?auto=compress&dpr=1&h=750&w=1260"
          alt="ENO and Particpants partners" /> */

          /*  src="https://images.pexels.com/photos/20356942/pexels-photo-20356942/free-photo-of-farmers-in-india.jpeg?auto=compress&cs=tinysrgb&w=1200"
           alt="Agrifood ecosystem network participants" /> */
             src="https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=900&auto=format&fit=crop"
          alt="Complex agricultural supply chain" />
      </div>
      <div className="abw-section__text">
       {/*  <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />Whom We Care About</p> */}
       <h4 className="container-title">
          Whom We Care About
          </h4>
        <h2 className="abw-h2">We care about Ecosystem Network Operators, their network participants, and the health of the ecosystems they operate.</h2>
        <p className="abw-body">We build for every participant in the agrifood ecosystem — from the farmer in the field to the commercial operators, community operators, sustaiability operators, public sector opeartor at scale.</p>
        <div className="abw-pill-row">
          {["Network Participants","Ecosystem Network Operators"].map(p => (
            <span key={p} className="abw-pill">{p}</span>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* ── THE PROBLEM WE SOLVE ─────────────────────────────── */}
  <div className="abw-section-wrap abw-section-wrap--grey">
    <div className="abw-section">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
          /* src="https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=900&auto=format&fit=crop" */
          src= "https://images.unsplash.com/photo-1545987796-200677ee1011?w=900&auto=format&fit=crop"
          alt="Complex agricultural supply chain" />
      </div>
      <div className="abw-section__text">
   {/*      <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />The Problem We Solve</p> */}
         <h4 className="container-title">
        The Problem We Solve
          </h4>
        <h2 className="abw-h2">Four interconnected dimensions of the ecosystem problem</h2>
        <div className="abw-problem-grid">
          <div className="abw-problem-card"><span className="abw-problem-dot" /><p className="abw-problem-title">Fragmented Ecosystem</p><p className="abw-problem-desc">
Participants + systems are disconnected</p></div>
          <div className="abw-problem-card"><span className="abw-problem-dot" /><p className="abw-problem-title">No Ecosystem Infrastructure</p><p className="abw-problem-desc">
Nothing orchestrates the entire network</p></div>
          <div className="abw-problem-card"><span className="abw-problem-dot" /><p className="abw-problem-title">No Ecosystem Ownership</p><p className="abw-problem-desc">
The organization cannot operate and govern the ecosystem as one</p></div>
          <div className="abw-problem-card"><span className="abw-problem-dot" /><p className="abw-problem-title">Lack of Ecosystem Monetization</p><p className="abw-problem-desc">Missed revenue opportunities</p></div>
        </div>
        <div className="abw-banner abw-banner--red">THE ECOSYSTEM ORCHESTRATION GAP: Organizations have ecosystems, but they lack the infrastructure to create and operate those digital ecosystems as one connected, governed, intelligent, and monetizable ecosystem network.</div>
      </div>
    </div>
  </div>

  {/* ── HOW WE DO IT ─────────────────────────────────────── */}
  <div className="abw-section-wrap">
    <div className="abw-section abw-section--rev">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
       /*    src="https://images.unsplash.com/photo-1518770660439-4636190af475?w=900&auto=format&fit=crop"
          alt="Technology and platform infrastructure" /> */
           src="https://images.pexels.com/photos/34212896/pexels-photo-34212896.jpeg?cs=srgb&dl=pexels-jakubzerdzicki-34212896.jpg&fm=jpg"
           alt="Software development workspace representing the GBR ecosystem application foundry" 
          
          />
      </div>
      <div className="abw-section__text">
        {/* <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />How We Do It</p> */}
         <h4 className="container-title">
        How We Do It
          </h4>
        <h2 className="abw-h2">Ecosystem Orchestration Plaform  — not just Infrastructure, but AI Ecosystem Builder Framework</h2>
        <p className="abw-body">We provide the Sovereign Ecosystem Infrastructure Stack to enable agrifood organisations to create, own and operate ecosystems networks:</p>
        <div className="abw-approach-grid">
          {["Agentic Network Operating System","Eosystem Operations Platform","AI Ecosystem Builder Framework"].map(item => (
            <div key={item} className="abw-approach-item"><span className="abw-approach-item__dot" />{item}</div>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* ── VISION & MISSION ─────────────────────────────────── */}
  <div id="vision-mission"
  className="abw-vm-band">
    <div className="abw-vm-inner">
      <div className="abw-vm-card">
      {/*   <p className="abw-vm-label">Vision</p> */}
        <h4 className="container-title">
           Vision
          </h4>
        <p className="abw-vm-text">Every organisation becomes an Ecosystem Operator .</p>
      </div>
      <div className="abw-vm-sep" />
      <div className="abw-vm-card">
    {/*     <p className="abw-vm-label">Mission</p> */}
        <h4 className="container-title">
           Mission
          </h4>
        <p className="abw-vm-text">Build ecosystem orechestartion paltform that enables agrifood organisations to create, orchestrate, operate and monetize their own ecosystem networks.</p>
      </div>
    </div>
  </div>

  {/* ── WHY ECOSYSTEM OWNERSHIP ──────────────────────────── */}
  <div className="abw-feature-band">
    <div className="abw-feature-band__inner">
     {/*  <p className="abw-eyebrow" style={{justifyContent:"center"}}><span className="abw-eyebrow__dot" />Why Ecosystem Ownership</p> */}
      <h4 className="container-title">
      Why Ecosystem Ownership
          </h4>
      <h2 className="abw-feature-band__title">The competitive advantage of the next decade</h2>
      <p className="abw-feature-band__sub">The next generation of organizations will not compete only through their products and operations. They will compete through the ecosystems they create and operate.<br></br>Operating your own ecosystem network gives you the ability to orchestrate participants & workflows, control your ecosystem data, create new value, unlock new revenue, and build resilient, sustainable growth.</p>
      <div className="abw-feature-grid">
        <div className="abw-feature-card"><p className="abw-feature-card__num">01</p><p className="abw-feature-card__title">Ecosystem Intelligence</p><p className="abw-feature-card__desc">Connect data across your ecosystem to create visibility, insights, and intelligent decisions.</p></div>
        <div className="abw-feature-card"><p className="abw-feature-card__num">02</p><p className="abw-feature-card__title">New Ecosystem Value</p><p className="abw-feature-card__desc">Create and monetize new services, transactions, and opportunities across your network.</p></div>
        <div className="abw-feature-card"><p className="abw-feature-card__num">03</p><p className="abw-feature-card__title">Network Orchestration</p><p className="abw-feature-card__desc">Coordinate participants, processes, assets, and handoffs across the entire ecosystem.</p></div>
        <div className="abw-feature-card"><p className="abw-feature-card__num">04</p><p className="abw-feature-card__title">Resilient & Sustainable</p><p className="abw-feature-card__desc">Build ecosystems that are more productive, resilient, inclusive, and sustainable over time.</p></div>
      </div>
    </div>
  </div>

  {/* ── CULTURE & VALUES ─────────────────────────────────── */}
  <div className="abw-culture-wrap">
    <div className="abw-culture-inner">
      <div className="abw-culture-header">
        <div className="abw-culture-header__left">
         {/*  <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />Our Culture & Values</p> */}
          <h4 className="container-title">
            Our Culture & Values
          </h4>
          <h2 className="abw-h2" style={{margin:0}}>Culture is how we reshape agrifood organisations</h2>
        </div>
        {/* <p className="abw-culture-header__tagline">Not what we say — but how we operate every single day.</p> */}
      </div>
      <div className="abw-culture-grid">
        <div className="abw-culture-card abw-culture-card--featured">
          <p className="abw-culture-card__number">01</p>
          <div className="abw-culture-card__bar" />
          <p className="abw-culture-card__title">Innovation-Led Value Creation</p>
          <p className="abw-culture-card__desc">Technology is not the product. Value creation is. We innovate to unlock new economic value across ecosystems — not for novelty, but for meaningful impact.</p>
        </div>
        <div className="abw-culture-card">
          <p className="abw-culture-card__number">02</p>
          <div className="abw-culture-card__bar" />
          <p className="abw-culture-card__title">Mission-Driven</p>
          <p className="abw-culture-card__desc">Singularly focused on one outcome: agrifood Organisations owning their ecosystem networks. Every decision is guided by this purpose.</p>
        </div>
        <div className="abw-culture-card">
          <p className="abw-culture-card__number">03</p>
          <div className="abw-culture-card__bar" />
          <p className="abw-culture-card__title">Ownership Thinking</p>
          <p className="abw-culture-card__desc">We build for control, autonomy, and long-term advantage — for our customers and for ourselves.</p>
        </div>
        <div className="abw-culture-card">
          <p className="abw-culture-card__number">04</p>
          <div className="abw-culture-card__bar" />
          <p className="abw-culture-card__title">Systems-Level Thinking</p>
          <p className="abw-culture-card__desc">We redesign entire ecosystems — not isolated parts. We see the whole chain and build for it.</p>
        </div>
        <div className="abw-culture-card">
          <p className="abw-culture-card__number">05</p>
          <div className="abw-culture-card__bar" />
          <p className="abw-culture-card__title">Partnership Over Vendor</p>
          <p className="abw-culture-card__desc">We are co-builders of ecosystem infrastructure — not just service providers.</p>
        </div>
        <div className="abw-culture-card">
          <p className="abw-culture-card__number">06</p>
          <div className="abw-culture-card__bar" />
          <p className="abw-culture-card__title">Equality for Everyone</p>
          <p className="abw-culture-card__desc">We uphold fairness, inclusivity, and respect — creating a culture where all participants thrive together.</p>
        </div>
      </div>
      <div className="abw-culture-bottom">
        <p className="abw-culture-bottom__label">Our philosophy</p>
        <div className="abw-culture-bottom__sep" />
        <p className="abw-culture-bottom__text">We are purpose-driven, ecosystem network operator-centric, collaborative, and innovative — united by the belief that organisations deserve to own, operate and benefit from the ecosystems they have.</p>
      </div>
    </div>
  </div>

  {/* ── SUSTAINABILITY ───────────────────────────────────── */}
  <div className="abw-section-wrap abw-section-wrap--grey">
    <div className="abw-section abw-section--rev">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
          src="https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=900&auto=format&fit=crop"
          alt="Sustainable farming and green agriculture" />
      </div>
      <div className="abw-section__text">
      {/*   <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />Our Sustainability Commitment</p> */}
         <h4 className="container-title">
            Our Sustainability Commitment
          </h4>
        <h2 className="abw-h2">Profitable ecosystems that are good for the planet</h2>
        <p className="abw-body">We believe commercial farming and sustainability are not in conflict — they are interdependent. Our platform empowers biodiversity value chains, reduces waste, and enables measurable environmental outcomes alongside financial growth.</p>
        <div className="abw-pill-row">
          {["Biodiversity tracking","Carbon footprint tools","Sustainable supply chains","ESG reporting"].map(p => (
            <span key={p} className="abw-pill">{p}</span>
          ))}
        </div>
      </div>
    </div>
  </div>

  {/* ── OUR TEAM ─────────────────────────────────────────── */}
  <div className="abw-section-wrap">
    <div className="abw-section">
      <div className="abw-section__img-col">
        <img className="abw-section__img"
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=900&auto=format&fit=crop"
          alt="GBR Farming team collaboration" />
      </div>
      <div className="abw-section__text">
       {/*  <p className="abw-eyebrow"><span className="abw-eyebrow__dot" />Our Team</p> */}

         <h4 className="container-title">
            Our Team
          </h4>
        <h2 className="abw-h2">Experts united by a shared purpose</h2>
        <p className="abw-body">The team behind GBR Farming combines deep expertise in agribusiness, technology, and system integration — all driven by the mission of enabling ecosystem ownership.</p>
        <div className="abw-team-grid">
          <div className="abw-team-card"><p className="abw-team-role">Core team</p><p className="abw-team-desc">Engineers, AI/IoT specialists, and platform architects building and scaling Network Platforms.</p></div>
          <div className="abw-team-card"><p className="abw-team-role">Ecosystem & partnerships</p><p className="abw-team-desc">Driving adoption and value creation with agrifood organisations worldwide.</p></div>
          <div className="abw-team-card"><p className="abw-team-role">Operations & impact</p><p className="abw-team-desc">Ensuring smooth deployment, reliable support, and measurable sustainability outcomes.</p></div>
          <div className="abw-team-card"><p className="abw-team-role">Advisory team</p><p className="abw-team-desc">Strategic leaders guiding ecosystem development and global growth.</p></div>
        </div>
      </div>
    </div>
  </div>

  {/* ══════════════════════════════════════════════════════════
      ── DIVISIONS CLOSING SECTION — REDESIGNED ─────────────
      Green header band → light grey tray with cards overlapping
      ══════════════════════════════════════════════════════════ */}
     
  <div   id="ecosystem-divisions"
         className="abw-div-outer">

    {/* GREEN INTRO BAND */}
    <div className="abw-div-intro-band">
      <div className="abw-div-intro-band__inner">
         <h4 className="container-title">
            Two Strategic Business Units. One Vision.
          </h4>
        <h2 className="abw-div-intro-band__h2">
          Building Enterprise Ecosystem Infrastructure<br />
          <em>-EEI Stack.</em>
        </h2>
        <p className="abw-div-intro-band__sub">
          Most organizations participate in ecosystems&mdash;but few are waiting to create, own, orchestrate, or monetize
          the ecosystem around thier industry. GBR provides the infrastructure to enable organisations to achieve this.
        </p>
      </div>
    </div>

    {/* LIGHT TRAY - cards lift out of green band */}
    <div className="abw-div-cards-tray">
      <div className="abw-div-cards-inner">

        {/* DIVISION CARDS */}
        <div className="abw-div-grid">

          {/* GBR FARMING BUSINESS UNIT */}
          <div className="abw-div-card abw-div-card--network">
            <span className="abw-div-card__badge">01 &middot; GBR Farming</span>
            <h3 className="abw-div-card__headline">Agriculture & Food Division</h3>
            <p className="abw-div-card__distinction">Helping agrifood ecosystem organizations become Ecosystem Operators.</p>
            <p className="abw-div-card__for">
              GBR Farming delivers AI-powered ecosystem solutions for agribusinesses, FPOs, CBBOs,
              cooperatives, NGOs, processors, exporters, input manufacturers, carbon project
              developers, and CSR programs.
            </p>
            <p className="abw-div-card__listlabel">What Ecosystem Operators Can Do</p>
            <ul className="abw-div-card__list">
              <li>Build and governing ecosystem networks</li>
              <li>Manage and orchestrate stakeholders with AI</li>
              <li>Launch ecosystem business models</li>
              <li>Measure economic, social, and environmental impact</li>
            </ul>
          </div>

          {/* GBR-TECH DIVISION */}
          <div className="abw-div-card abw-div-card--si">
            <span className="abw-div-card__badge">02 &middot; GBR-Tech</span>
            <h3 className="abw-div-card__headline">Platform & Technology Division</h3>
            <p className="abw-div-card__distinction">Building the AI-native ecosystem opearting infrastructure.</p>
            <p className="abw-div-card__for">
              GBR-Tech develops the Ecosystem Operating Infrastructure (EOI), Agentic & Autonomous Business Network (ABN) Reference Architecture and
              GBR.Network&mdash;the industry-agnostic platform that enables organizations to build, orc
              govern, and scale ecosystem networks across industries.
            </p>
            <p className="abw-div-card__listlabel">What We Build</p>
            <ul className="abw-div-card__list">
              <li> Ecosystem Operating Infrastructure (EOI)</li>
              <li>ABN Reference Architecture</li>
              <li>GBR.Network Platform</li>
              <li>AI-native Ecosystem Infrastructure</li>
            </ul>
          </div>

        </div>

        {/* TOGETHER - UNIFYING CLOSING BLOCK */}
        <div className="abw-div-together">
          <h3 className="abw-div-together__title">One Infrastructure. One Industry Platform. Infinite Ecosystem Networks.</h3>

          

          <p className="abw-div-together__text">
            GBR-Tech builds the <em>ecosystem operating infrastructure.</em>
          </p>
          <p className="abw-div-together__text">
            GBR Farming transforms it into <em>Agrifood Ecosystem Orchestration Platform (EOP).</em>
          </p>
          <p className="abw-div-together__text">
            Together, they create a scalable AI-native ecosystem platform where every agrifood ecosystem 
            organization becomes an Ecosystem Network Operator 
          </p>
        </div>

      </div>
    </div>
  </div>

</div>

{/* End of about us page */}

{/* End of about us page */}
{/* 
      <FooterComponent /> */}
    </>
  );
}
